import { useRecoilValue } from 'recoil';
import { authAtom } from '../_state';
import axios from 'axios';

const useAuth = () => {
  const auth = useRecoilValue(authAtom);
  return auth;
};

const authUtils = {
  useIsLogin: () => {
    const auth = useAuth();
    return !!auth;
  },
  useIsManager: () => {
    const auth = useAuth();
    if (auth?.scale === 'N') {
      return false;
    }
    return auth?.role === 'ROLE_MANAGER' || auth?.role === 'ROLE_ADMIN';
  },
  useIsAdmin: () => {
    const auth = useAuth();
    return auth?.role === 'ROLE_ADMIN';
  },
  useIsDidas: async (key) => {
    return await axios
      .get('/api/auth/is-didas', {
        params: {
          key: key
        }
      })
      .then(async (result) => {
        return result;
      })
      .catch(async (error) => {
        return { success: false };
      });
  }
};

export { authUtils };
